import React from 'react';
import './ActivityMetrics.css';

function ActivityMetrics({ data }) {
    const metrics = [
        {
            label: 'Candidates Sourced',
            value: data?.candidatesSourced || 0,
            color: '#3b82f6'
        },
        {
            label: 'Applications Received',
            value: data?.applicationsReceived || 0,
            color: '#8b5cf6'
        },
        {
            label: 'Phone Screens Completed',
            value: data?.phoneScreensCompleted || 0,
            color: '#10b981'
        },
        {
            label: 'HM 1st Interviews',
            value: data?.hmFirstInterviews || 0,
            color: '#f59e0b'
        },
        {
            label: 'HM 2nd Interviews',
            value: data?.hmSecondInterviews || 0,
            color: '#ec4899'
        },
        {
            label: 'Offers Extended',
            value: data?.offersExtended || 0,
            color: '#6366f1'
        }
    ];

    return (
        <div className="activity-metrics-container">
            <h2 className="activity-metrics-title">Recruitment Activity</h2>
            <div className="activity-metrics-grid">
                {metrics.map((metric, index) => (
                    <div
                        key={index}
                        className="activity-metric-card"
                        style={{ borderTopColor: metric.color }}
                    >
                        <div className="activity-metric-value" style={{ color: metric.color }}>{metric.value}</div>
                        <div className="activity-metric-label">{metric.label}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ActivityMetrics;
